import { Modal, SystemText, Table } from 'e4shared';
import { skillColour } from 'helpers/metrics';
import { translateSkill } from 'helpers/translations';
import React from 'react';
import { useSelector } from 'react-redux';

export const Skills = ({ show, close }) => {
    const [skills, setSkills] = React.useState([]);
    const [behaviour, setBehaviour] = React.useState('-');
    const [mappedSkills, setMappedSkills] = React.useState([]);
    const [sortBy, setSortBy] = React.useState('score');
    const [descending, setDescending] = React.useState(true);

    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        if (show?.skills) {
            setSkills(JSON.parse(show.skills));
        } else {
            setSkills([]);
        }

        if (show?.competency_Names?.length) {
            setBehaviour(show.competency_Names[0]);
        } else {
            setBehaviour('-');
        }
    }, [show]);

    React.useEffect(() => {
        if (skills) {
            const d = descending ? -1 : 1;
            setMappedSkills(
                skills
                    .map(s => translateSkill(user.language_Code, s))
                    .map(s => ({ skill: s.title, score: s.score }))
                    .sort((a, b) => (a[sortBy] > b[sortBy] ? 1 * d : -1 * d))
            );
        } else {
            setMappedSkills([]);
        }
    }, [skills, sortBy, descending]);

    const tableColumns = [
        {
            label: SystemText('LearningTracker/Skills/Table/Behavior'),
            dataProperty: 'behaviour',
            format: () => <span>{behaviour}</span>,
        },
        { label: SystemText('LearningTracker/Skills/Table/Skill'), dataProperty: 'skill' },
        {
            label: SystemText('LearningTracker/Skills/Table/Score'),
            dataProperty: 'score',
            className: 'text-center',
            format: x => <label className={`label label-light-${skillColour(x)}`}>{parseInt(x, 10)}%</label>,
        },
    ];

    const options = {
        hidePaging: true,
        tableClass: 'table table-striped',
        sortBy,
        ascending: !descending,
    };

    const triggerSort = React.useCallback(
        column => {
            column === sortBy && setDescending(!descending);
            setSortBy(column);
        },
        [sortBy, descending]
    );

    return (
        <Modal show={show} title={show.title} close={close} footer={null}>
            <Table data={mappedSkills} columns={tableColumns} options={options} sort={triggerSort} />
        </Modal>
    );
};

export default Skills;
